<template>
  <div class="home">
    <ProgressStep step=2 />
    <p class="stepReminder">Étape 2/4</p>
    <h1>À propos de ma famille</h1>
    <div class="inputFrame">
      <label for="nChild">Nombre d’enfants rattachés au foyer fiscal de mes parents<br>(autre que toi et qui ne sont pas dans l'enseignement supérieur)</label>
      <input
        id="nChild"
        type="number"
        v-model="$store.state.nChild"
        @keyup="isNChildValid()"
        @keydown.enter="goToNext()"
        class="inputFocus"
        :class="{ 'inputError' : !nChildIsValid }"
        placeholder=""
        autocomplete="off"
      >
    </div>
    <div class="inputFrame">
      <label for="nChildUp">Nombre de frères et sœurs étudiants dans l’enseignement supérieur</label>
      <input
        id="nChildUp"
        type="number"
        v-model="$store.state.nChildUp"
        @keyup="isNChildUpValid()"
        @keydown.enter="goToNext()"
        class="inputFocus"
        :class="{ 'inputError' : !nChildUpIsValid }"
        placeholder=""
        autocomplete="off"
      >
    </div>
    <button @click="goToNext()" class="submit-button" :style="disabled">
      <span class="insivibleSpacer"></span>
      <span>Étape suivante</span>
      <img src="assets/icon/fleche-droite.svg" alt="Étape suivante">
    </button>
    <button @click="$router.push({ name: 'Etape-1' })" class="submit-button-back">
      <img src="assets/icon/fleche-gauche.svg" alt="Étape précédente">
      <span>Étape précédente</span>
    </button>
  </div>
</template>

<script>
// @ is an alias to /src
import ProgressStep from '@/components/ProgressStep.vue'

export default {
  name: 'Etape2',
  components: {
    ProgressStep
  },
  data () {
    return {
      nChildIsValid: true,
      nChildUpIsValid: true,
      disabled: 'background-color: #C3C4CA'
    }
  },
  mounted () {
    this.$store.state.nChild !== null && this.isNChildValid()
    this.$store.state.nChildUp !== null && this.isNChildUpValid()
  },
  methods: {
    goToNext () {
      if (typeof this.$store.state.nChild === 'number' && 
        typeof this.$store.state.nChildUp === 'number' && 
        this.$store.state.nChild >= 0 &&
        this.$store.state.nChildUp >= 0) {
        this.$router.push({ name: 'Etape-3' })
      } else {
        if (typeof this.$store.state.nChild !== 'number' || this.$store.state.nChild < 0) {
          this.nChildIsValid = false
        }
        if (typeof this.nChildUp !== 'number' || this.$store.state.nChildUp < 0) {
          this.nChildUpIsValid = false
        }
      }
    },
    isNChildValid () {
      if (typeof this.$store.state.nChild === 'number' && this.$store.state.nChild >= 0) {
        this.nChildIsValid = true
        if (typeof this.$store.state.nChildUp === 'number' && this.$store.state.nChildUp >= 0) {
          this.disabled = ''
        }
      } else {
        this.nChildIsValid = false
        this.disabled = 'background-color: #C3C4CA'
      }
    },
    isNChildUpValid () {
      if (typeof this.$store.state.nChildUp === 'number' && this.$store.state.nChildUp >= 0) {
        this.nChildUpIsValid = true
        if (typeof this.$store.state.nChild === 'number' && this.$store.state.nChild >= 0) {
          this.disabled = ''
        }
      } else {
        this.nChildUpIsValid = false
        this.disabled = 'background-color: #C3C4CA'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .inputFrame {
    margin-top: 30px;
    input {
      border: solid 1px #9FA7A7;
      border-radius: 3px;
      padding: 11px 13px;
      width: calc(100% - 28px);
      font-weight: 400;
      font-size: 17px;
      color: #000000;
      text-align: left;
      margin-top: 10px;
    }
  }
  @media screen and (min-width: 585px) {
    .inputFrame {
      input {
        width: unset;
      }
    }
  }
</style>
